import { useQuery } from 'react-query';
import { fetcher } from '../../client'
import { fetchCategoryList } from '../../actions/categories'

export function useCategoryList(params, options) {
  return useQuery(['categories', params], () => fetcher(fetchCategoryList(params)), options)
}

